// Minimum versions are from October 2023. Further info: https://www.browsers.fyi/feed/
export default {
  Chrome: 118,
  Samsung: 23,
  Firefox: 118,
  Safari: 17,
  Edge: 118,
  Opera: 104,
};
